import { type Dispatch, type SetStateAction } from "react";

import {
  KpiType,
  type ModelMetadataKpiFormula,
} from "@features/mmm/components/explore-budgets/client-setting/types";
import { Checkbox } from "@shared/checkbox";

import {
  OBSERVED_SPEND_ID,
  OBSERVED_SPEND_LEGEND,
  REVENUE_ID,
  REVENUE_LEGEND,
  ROAS_ID,
  ROAS_LEGEND,
} from "./const";

type Props = {
  selectedKpi: ModelMetadataKpiFormula;
  datasetVisibility: Record<string, boolean>;
  setDatasetVisibility: Dispatch<SetStateAction<Record<string, boolean>>>;
};

export function Legend({
  selectedKpi,
  datasetVisibility,
  setDatasetVisibility,
}: Props) {
  const toggleDatasetVisibility =
    (datasetId: keyof typeof datasetVisibility) => (checked: boolean) =>
      setDatasetVisibility((prev: typeof datasetVisibility) => ({
        ...prev,
        [datasetId]: checked,
      }));

  const isRevenue = selectedKpi.kpi_type === KpiType.REVENUE;

  return (
    <div className="flex text-xs space-x-4 px-6 pt-4 pb-2">
      <label className="flex items-center space-x-0.5 cursor-pointer">
        <Checkbox
          value={datasetVisibility[ROAS_ID]}
          onChange={toggleDatasetVisibility(ROAS_ID)}
        />
        <div dangerouslySetInnerHTML={{ __html: ROAS_LEGEND }} />
        <div>i{isRevenue ? "ROAS" : "CAC"}</div>
      </label>
      <label className="flex items-center space-x-0.5 cursor-pointer">
        <Checkbox
          value={datasetVisibility[REVENUE_ID]}
          onChange={toggleDatasetVisibility(REVENUE_ID)}
        />
        <div dangerouslySetInnerHTML={{ __html: REVENUE_LEGEND }} />
        <div>{selectedKpi.friendly_name}</div>
      </label>
      <label className="flex items-center space-x-0.5 cursor-pointer">
        <Checkbox
          value={datasetVisibility[OBSERVED_SPEND_ID]}
          onChange={toggleDatasetVisibility(OBSERVED_SPEND_ID)}
        />
        <div dangerouslySetInnerHTML={{ __html: OBSERVED_SPEND_LEGEND }} />
        <div>Observed Spend (weekly)</div>
      </label>
    </div>
  );
}
